import { LATITUDE_RE } from '../regexes';

export function validateLatitude(value) {
    const type = typeof value;
    if (type !== 'number' && type !== 'string') {
        return false;
    }
    if (type === 'number') {
        value = value.toString();
    }
    return LATITUDE_RE.test(value);
}
